import { FC } from 'react'

import RFFFields from '../../react-final-form-fields'
import { validateRequired, validateMaxSymbols, composeValidators } from '../../../../util/validation'
import { nameofFactory, getPlaceholderTextFromLabel } from '../../../../util'

import { TrainingGroupFormFieldsProps, ITrainingGroupValues } from './training-group-form-types'

const validateMaxSymbols100 = validateMaxSymbols(100, 'Field must not exceed 100 characters')
const validateMaxSymbols500 = validateMaxSymbols(500, 'Field must not exceed 500 characters')

const nameof = nameofFactory<ITrainingGroupValues>()

const nameLabel = 'Name'
const descriptionLabel = 'Description'
const sortOrderLabel = 'Sort Order'
const activeLabel = 'Active'

const TrainingGroupFormFields: FC<TrainingGroupFormFieldsProps> = props => {
  const { disabled } = props

  return (
    <>
      <RFFFields.Input
        name={nameof('name')}
        label={nameLabel}
        placeholder={getPlaceholderTextFromLabel(nameLabel)}
        disabled={disabled}
        validate={composeValidators(validateRequired, validateMaxSymbols100)}
      />

      <RFFFields.Input
        name={nameof('description')}
        label={descriptionLabel}
        placeholder={getPlaceholderTextFromLabel(descriptionLabel)}
        disabled={disabled}
        validate={validateMaxSymbols500}
      />

      <RFFFields.MaskedInput
        type="number"
        name={nameof('sortOrder')}
        label={sortOrderLabel}
        placeholder={getPlaceholderTextFromLabel(sortOrderLabel)}
        disabled={disabled}
      />

      <RFFFields.Switch name="isActive" label={activeLabel} onLabel="yes" offLabel="no" disabled={disabled} />
    </>
  )
}

export default TrainingGroupFormFields
